import { render, staticRenderFns } from "./TableCollapseProducts.vue?vue&type=template&id=387f4a9c&scoped=true"
import script from "./TableCollapseProducts.vue?vue&type=script&lang=js"
export * from "./TableCollapseProducts.vue?vue&type=script&lang=js"
import style0 from "./TableCollapseProducts.vue?vue&type=style&index=0&id=387f4a9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387f4a9c",
  null
  
)

export default component.exports